import { gender } from 'utils';

function formatGender(value: genderValue) {
  return gender.format(value);
}

export { formatGender };
